import { LANGUAGES } from "../../../../../constants/index";

export interface FormState {
    informationMode: string;
    informationModeId: string;
    supportOfSale: Record<string, any>;
    modeOfSale: any[];
    tagsData: any[];
    displayName: string;
    advancedDisplayName: { languages: Record<string, string> };
    title: string;

    inputInformationMode: boolean;
    inputSupportOfSale: boolean;
    inputModeOfSale: boolean;
    selectName: boolean;
    isNameExist: boolean;
}

export type FormAction =
    | { type: "SET_FIELD"; field: string; value: any }
    | { type: "SET_FIELDS"; fields: Partial<FormState> }
    | { type: "RESET" }
    | { type: "RESET_VALIDATION" }
    | { type: "SET_VALIDATION"; errors: any }
    | { type: "ADD_MODE_OF_SALE"; payload: any }
    | { type: "SET_MODE_OF_SALE"; payload: any }
    | { type: "REMOVE_MODE_OF_SALE_ERROR" };

export const initialFormState: FormState = {
    informationMode: "",
    informationModeId: "",
    supportOfSale: {},
    modeOfSale: [],
    tagsData: [],
    displayName: "",
    advancedDisplayName: { languages: LANGUAGES },
    title: "",

    inputInformationMode: false,
    inputSupportOfSale: false,
    inputModeOfSale: false,
    selectName: false,
    isNameExist: false,
};

export function formReducer(state: FormState, action: FormAction): FormState {
    switch (action.type) {
        case "SET_FIELD":
            return { ...state, [action.field]: action.value };

        case "SET_FIELDS":
            return { ...state, ...action.fields };

        case "RESET":
            return { ...initialFormState };

        case "RESET_VALIDATION":
            return {
                ...state,
                inputInformationMode: false,
                inputSupportOfSale: false,
                inputModeOfSale: false,
                selectName: false,
                isNameExist: false,
            };

        case "SET_VALIDATION":
            return { ...state, ...action.errors };

        default:
            return state;
    }
}
